export default __webpack_public_path__ + "static/media/sugianto.b862a291.jpg";